import { useQuery } from "@tanstack/react-query"
import { paths } from "../apiTypes"

export type EntitiesSummaryResponse =
  paths["/v2/vault/entities/summary"]["get"]["responses"]["200"]["content"]["application/json"]

function getApiBase() {
  return process.env.NEXT_PUBLIC_EULER_API_URL ?? "http://localhost:42069"
}

export function useVaultEntitiesSummary(
  chainId?: number,
  {
    enabled = true,
  }: {
    enabled?: boolean
  } = {},
) {
  return useQuery<EntitiesSummaryResponse>({
    queryKey: ["vaultEntitiesSummary", chainId],
    queryFn: async () => {
      const url = `${getApiBase()}/v2/vault/entities/summary?chainId=${encodeURIComponent(
        String(chainId ?? 0),
      )}`
      const res = await fetch(url)
      if (!res.ok) {
        throw new Error(`Failed to fetch entities summary: ${res.status}`)
      }
      return res.json()
    },
    enabled: enabled && !!chainId,
    refetchOnWindowFocus: false,
  })
}
